import React from 'react';
import propTypes from 'prop-types';
import RichTextContent from 'tailwind-components/RichTextContent/RichTextContent';
import { Megaphone } from 'lucide-react';
import { cn } from 'lib/utils';
import { hasOepCarrierNote } from 'helpers/oepUpdates';

// the unlayered `a` rule in _generics.scss strips underline and color and beats
// every layered utility, so these need `!` to read as links at all
const NOTE_LINK_CLASSES =
  '[&_a]:underline! [&_a]:underline-offset-2 [&_a]:text-primary-darkened! [&_a]:transition-colors [&_a:hover]:text-primary-emphasis!';

/**
 * full-width card directly under the carrier header: whatever the carrier
 * wants to highlight this OEP, from the `OEP Carrier Notes` field. zoho returns
 * it as html, so it renders through RichTextContent (sanitized html, markdown
 * fallback for tag-free notes). renders nothing when the field is empty. the
 * megaphone matches OEP_UPDATE_ICON_NAME/COLOR used by the Carrier
 * Appointments badge, so the note reads as part of the same OEP language.
 * @param carrier - normalized carrier from carrierFactory
 */
export default function CarrierNotesPanel({ carrier }) {
  if (!hasOepCarrierNote(carrier)) return null;

  return (
    <div
      data-tour='oep-carrier-notes'
      className='rounded-xl border border-grey-lightest bg-white p-4 lg:p-6'
    >
      <div className='mb-3 flex items-center gap-2'>
        <Megaphone aria-hidden className='size-5 shrink-0 text-amber-600' />
        <h3 className='m-0 text-xl font-semibold text-black'>Carrier Notes</h3>
      </div>
      <RichTextContent
        content={carrier.oepNotes.trim()}
        className={cn('text-left text-grey', NOTE_LINK_CLASSES)}
      />
    </div>
  );
}

CarrierNotesPanel.propTypes = {
  carrier: propTypes.object.isRequired
};
